import { Tag } from 'antd';
import { languages } from '../../heygen/components/language';

const languageLabels = new Map(
  languages.map(({ value, label }) => [value, label]),
);

export function VideoTranslationLanguageTag(props: {
  source: string | undefined;
  target: string | undefined;
}) {
  if (!props.target) {
    return null;
  }

  const sourceLang = props.source ?? '自动检测';
  const targetLang = languageLabels.get(props.target) ?? props.target;

  return (
    <Tag>
      语种：{sourceLang} → {targetLang}
    </Tag>
  );
}
